import { useCallback, useEffect, useState } from 'react';
import {
  defaultSiteSettings,
  readCachedSiteSettings,
  siteSettingsService,
  type PlatformSiteSettings,
} from '../services/siteSettingsService';

export function useMainSiteAccessGate() {
  const [settings, setSettings] = useState<PlatformSiteSettings>(() => {
    return readCachedSiteSettings() ?? defaultSiteSettings();
  });
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    const res = await siteSettingsService.getPlatformSettings();
    if (res.data) setSettings(res.data);
    else setSettings(defaultSiteSettings());
    setLoaded(true);
  }, []);

  useEffect(() => {
    void refresh();
    const onChange = () => {
      void refresh();
    };
    window.addEventListener('d88-site-access-changed', onChange);
    return () => window.removeEventListener('d88-site-access-changed', onChange);
  }, [refresh]);

  return {
    loaded,
    lockEnabled: settings.main_site_password_lock_enabled,
    accessCode: settings.main_site_access_code,
    settings,
    refresh,
  };
}
